import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";

const AvisoAutocheck = ({ aceptar, cancelar, disableback }) => {
  return (
    <ModalAutoT
      disableback={disableback}
      title={"Aviso"}
      desc={
        "Por motivo de seguridad debe comenzar nuevamente el proceso de checkin"
      }
      textBtnOne={"ACEPTAR"}
      handleChange={{
        btnOne: aceptar,
      }}
    />
  );
};

export default AvisoAutocheck;
